<div class="d-flex">
  @if (modificationManuelle) {
    <div class="mg-t-5">
      <i class="fas fa-square col-edited-color mg-r-5 border"></i>Modification manuelle
    </div>
  }
  @if (colonneModifiable) {
    <div class="mg-t-5">
      <i class="fas fa-square col-editable-color mg-l-20 mg-r-5 border"></i>Colonne modifiable
    </div>
  }
  @if (colonneInformations) {
    <div class="mg-t-5">
      <i class="fas fa-square col-info-color mg-l-20 mg-r-5 border"></i>Colonne avec informations supplémentaires
    </div>
  }
  @if (colonneObligatoire) {
    <div class="mg-t-5">
      <i class="fas fa-square col-madatory-color mg-l-20 mg-r-5 border"></i>Colonne obligatoire
    </div>
  }
  @if (celluleActive) {
    <div class="mg-t-5">
      <i class="fas fa-square col-cell-checked mg-l-20 mg-r-5 border"></i>Actif
    </div>
  }
  @if (celluleInactive) {
    <div class="mg-t-5">
      <i class="fas fa-square col-cell-unchecked mg-l-20 mg-r-5 border"></i>Inactif
    </div>
  }
  @if (celluleDescription) {
    <div class="mg-t-5 mg-l-20 mg-r-5">
      Cliquez sur une cellule afin de passer d'un état à un autre (Actif/Inactif)
    </div>
  }
</div>
